import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IGetArticleAttachmentRequest, IGetArticleAttachmentResponse} from "../types/IGetArticleAttachment";

export const getArticleApi = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        getArticleAttachment: builder.mutation<IGetArticleAttachmentResponse, IGetArticleAttachmentRequest>({
            query: (params) => ({
                url: apiLink.article.attachmentDownload({})({attachmentId: params.attachment_id}),
                method: "POST",
                body: params
            })
        })
    })
});

export const {useGetArticleAttachmentMutation} = getArticleApi;
